import Repo from './Repo.js'

export default class UserCheckoutFormRepository extends Repo {
  constructor () {
    super('user-checkout-forms')
  }

  all (q) {
    return super.all(q)
  }

  store (data) {
    return super.store(data)
  }

  update (id, data) {
    return super.update(id, data)
  }

  get (id, include) {
    return super.get(id, {include: include})
  }

  delete (id) {
    return super.delete(id)
  }

  paginate (q) {
    return super.paginate(q)
  }

  search (data) {
    return super.search(data)
  }

  declineAll (data) {
    return this.http.post(this.resource + '/decline', data).then((response) => {
      return Promise.resolve(response)
    }).catch((response) => {
      return Promise.reject(response)
    })
  }

  approveAll (data) {
    return this.http.post(this.resource + '/approve', data).then((response) => {
      return Promise.resolve(response)
    }).catch((response) => {
      return Promise.reject(response)
    })
  }

  returnedAll (data) {
    return this.http.post(this.resource + '/return', data).then((response) => {
      return Promise.resolve(response)
    }).catch((response) => {
      return Promise.reject(response)
    })
  }

  searchBySelections (data) {
    return this.http.post(this.resource + '/search', data).then((response) => {
      return Promise.resolve(response)
    }).catch((response) => {
      return Promise.reject(response)
    })
  }

  getWarehouseTransactions(id, data, include){
    data.include = include;
    return this.http.get(this.resource + '/' + id + '/warehouse-transactions', data).then((response) => {
      return Promise.resolve(response)
    }).catch((response) => {
      return Promise.reject(response)
    })
  }

  getStatuses(id, include, data) {
    if(data) {
      data.orderBy = 'created_at,desc';
    }
    if(include) {
      data.include = include
    }
    return this.http.get(this.resource + '/' + id + '/user-checkout-form-statuses', data).then((response) => {
      return Promise.resolve(response)
    }).catch((response) => {
      return Promise.reject(response)
    })
  }

  activeUserCheckoutFormsExport(id, name = "User checkout form") {
    return this.http.download(this.resource + '/' + id + '/export').then((response) => {
      let blob = new Blob([response.data], { type:   'application/pdf' } );
      let link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = name+'.pdf';
      link.click();
      return Promise.resolve(response);
    }).catch((response) => {
      return Promise.reject(response)
    })
  }

  getProducts(id){
    return this.http.get(this.resource + '/' + id + '/products').then((response) => {
      return Promise.resolve(response)
    }).catch((response) => {
      return Promise.reject(response)
    })
  }

  returnExpandable(data) {
    return this.http.post(this.resource + '/return-expandable', data).then((response) => {
      return Promise.resolve(response)
    }).catch((response) => {
      return Promise.reject(response)
    })
  }

}
